export default {
  data() {
    return {
      //airway
      mainAirwayTypeList: [
        { 'id': 1, 'title': 'مانور' },
        { 'id': 2, 'title': 'ایروی' },
        { 'id': 3, 'title': 'ساکشن' },
        { 'id': 4, 'title': 'بستن کلار گردنی' },
        { 'id': 5, 'title': 'BVM' },
        { 'id': 6, 'title': 'LMA' },
        { 'id': 7, 'title': 'اینتوبیشن' },
      ],
      //breath
      mainBreathTypeList: [
        { 'id': 8, 'title': 'اکسیژن تراپی' },
        { 'id': 9, 'title': 'نیدل تراکئوستومی' },
        { 'id': 10, 'title': 'ساکشن' },
        { 'id': 11, 'title': 'پانسمان سه طرفه' },
      ],
      //blood
      mainBloodTypeList: [
        { 'id': 12, 'title': 'سرم تراپی' },
        { 'id': 13, 'title': 'بستن تورنیکه' },
        { 'id': 14, 'title': 'پانسمان فشاری' },
        { 'id': 15, 'title': 'برقراری راه وریدی IV' },
      ],
      //unmoved
      mainUnmovedTypeList: [
        { 'id': 16, 'title': 'بی حرکت سازی لگن' },
        { 'id': 17, 'title': 'بی حرکت سازی فمور' },
        { 'id': 18, 'title': 'آتل شانه یا اسلینگ' },
        { 'id': 19, 'title': 'مراقبت اندام قطع شده' },
        { 'id': 20, 'title': 'پانسمان ساده' },
        { 'id': 49, 'title': 'پانسمان فشاری' },
        { 'id': 60, 'title': 'آتل اندام' },

      ],
      //moved
      mainMovedTypeList: [
        { 'id': 21, 'title': 'KED' },
        { 'id': 22, 'title': 'تخته بلند پشتی (LBB)' },
        { 'id': 23, 'title': 'گرم نگه داشتن بیمار' },
      ],
      //other part
      allUsesGeneralAction: [
        { 'id': 24, 'title': 'اکسیژن درمانی نازال' },
        { 'id': 25, 'title': 'اکسیژن درمانی با ماسک' },
        { 'id': 26, 'title': 'باز کردن راه هوایی' },
        { 'id': 27, 'title': 'گذاشتن ایروی' },
        { 'id': 5, 'title': 'BVM' },
        { 'id': 6, 'title': 'LMA' },
        { 'id': 7, 'title': 'اینتوبیشن' },
        { 'id': 50, 'title': 'ساکشن' },
        { 'id': 9, 'title': 'نیدل تراکئوستومی' },
        { 'id': 28, 'title': 'ماسک نبولایزر' },
        { 'id': 29, 'title': 'اسپری دارو با دمیار' },
        { 'id': 30, 'title': 'باز کردن راه وریدی' },
        { 'id': 31, 'title': 'تهویه مکانیکی' },
        { 'id': 32, 'title': 'کاپنوگرافی' },
        { 'id': 33, 'title': 'پالس اکسیمتری مدام' },
        { 'id': 34, 'title': 'کو اکسیمتری' },
        { 'id': 35, 'title': 'تجویز خوراکی دارو' },
        { 'id': 36, 'title': 'تجویز زیر زبانی' },
        { 'id': 37, 'title': 'تزریق عضلانی دارو' },
        { 'id': 38, 'title': 'تزریق وریدی دارو' },
        { 'id': 39, 'title': 'تزریق داخل استخوانی' },
        { 'id': 12, 'title': 'سرم تراپی' },
        { 'id': 40, 'title': 'مانیتورینگ مداوم' },
        { 'id': 41, 'title': 'ECG' },
        { 'id': 42, 'title': 'القای شوک' },
        { 'id': 43, 'title': 'اتصال به AED' },
        { 'id': 44, 'title': 'فشردن قفسه سینه' },
        { 'id': 45, 'title': 'کنترل خونریزی' },
        { 'id': 46, 'title': 'سوچور' },
        { 'id': 47, 'title': 'مهار فیزیکی بیمار ' },
        { 'id': 23, 'title': 'گرم نگه داشتن بیمار' },
        { 'id': 48, 'title': 'شیلد سوختگی' },
        { 'id': 51, 'title': 'پانسمان فشاری' },
        { 'id': 58, 'title': 'مشاوره لازم' },
        { 'id': 59, 'title': 'ثابت سازی' },
      ],
      selectedGeneralAction: [],
      selectedGeneralActionModel: [],
      modiriatDarmaniZayeman: [
        { 'id': 52, 'title': 'زایمان کامل نوزاد' },
        { 'id': 53, 'title': 'کلامپ کردن بند ناف' },
        { 'id': 54, 'title': 'بریدن بند ناف' },
        { 'id': 55, 'title': 'گرم کردن نوزاد' },
        { 'id': 56, 'title': 'خشک کردن نوزاد' },
        { 'id': 57, 'title': 'تحریک به گریه برای نوزاد' },
      ],
    };
  },
  methods: {
    addItem: function (id, state) {
      let flag = true;
      let stateText = '';
      if (state == 0) {
        stateText = id + 'after';
      } else {
        stateText = id + 'before';
      }
      for (let i = 0; i < this.selectedGeneralAction.length; i++) {
        if (this.selectedGeneralAction[i] == stateText) {
          this.selectedGeneralAction.splice(i, 1);
        }
      }
      for (let i = 0; i < this.selectedGeneralActionModel.length; i++) {
        if (
          this.selectedGeneralActionModel[i].generalActionId == id &&
          this.selectedGeneralActionModel[i].generalActionType == state
        ) {
          this.selectedGeneralActionModel.splice(i, 1);
          flag = false;
        }
      }
      if (flag) {
        this.selectedGeneralAction.push(stateText);
        let data = {
          generalActionId: id,
          generalActionType: state,
          patientId: this.patientId,
        };
        this.selectedGeneralActionModel.push(data);
      }
    },
    setData: function (data) {
      this.selectedGeneralAction = [];
      this.selectedGeneralActionModel = [];
      if (this.missionType == 'truma') {
        for (let i = 0; i < data.length; i++) {
          let temp = {
            generalActionId: data[i].generalAction.id,
            generalActionType: data[i].generalActionType,
            patientId: this.patientId,
          };
          this.selectedGeneralActionModel.push(temp);
          if (data[i].generalActionType == 0) {
            let stateText = data[i].generalAction.id + 'after';
            this.selectedGeneralAction.push(stateText);
          } else {
            let stateText = data[i].generalAction.id + 'before';
            this.selectedGeneralAction.push(stateText);
          }
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          let temp = {
            generalActionId: data[i].generalAction.id,
            generalActionType: data[i].generalActionType,
            patientId: this.patientId,
          };
          this.selectedGeneralActionModel.push(temp);
          if (data[i].generalActionType == 0) {
            let stateText = data[i].generalAction.id + 'after';
            this.selectedGeneralAction.push(stateText);
          } else {
            let stateText = data[i].generalAction.id + 'before';
            this.selectedGeneralAction.push(stateText);
          }
        }
      }
    },
    patientGeneralActionAdded: function () {
      try {
        this.$root.$refs.FollowUpPatient.changeTab(4);
        this.$root.$refs.FollowUpPatient.changeTab4Step(1, true);
      } catch (error) { console.log("A error :", error); }
      try {
        this.$root.$refs.ReportFormFollowUp.reloadApiFun(9, this.isGoToNext, 10);
        this.isGoToNext = false
      } catch (error) { console.log("A error :", error); }
    },
    goToNextStep: function () {
      let tempPatientGeneralAction = {
        patientGeneralActions: [],
        patientId: this.patientId,
      };
      for (let i = 0; i < this.selectedGeneralActionModel.length; i++) {
        tempPatientGeneralAction.patientGeneralActions.push({
          generalActionId: this.selectedGeneralActionModel[i].generalActionId,
          generalActionType: this.selectedGeneralActionModel[i].generalActionType,
        });
      }
      this.addRangePatientGeneralActionFunction(tempPatientGeneralAction);
    },
    backToStep10: function () {
      this.$root.$refs.FollowUpPatient.changeTab3Step(2, true);
    },
  },
};
